import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ApiModulesService} from 'src/app/api-modules.service';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {data} from 'jquery';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-create-page',
    templateUrl: './create-page.component.html',
    styleUrls: ['./create-page.css']
})
export class CreatePageComponent implements OnInit {

    public generalForm: UntypedFormGroup;
    public seoForm: UntypedFormGroup;
    public active = 1;
    public countryname = [];
    public id: string;
    public todo = [];

    public done = [];

    checkoutForm = this.formBuilder.group({
        name: this.formBuilder.array([]),
        id: this.route.snapshot.paramMap.get('id'),
        userid: ''
    });
    username: void;
    name: any[];

    constructor(public apiModulesService: ApiModulesService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.getUserName();
        // this.getCountriesName();
        this.getExternalChannel();
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex,
            );
            this.checkoutForm.value.name.push(this.done[event.currentIndex].channel_id);
        }
    }

    // public getCountriesName(){
    //   this.apiModulesService.get("telegram/channel/list").subscribe((data)=>
    //   {
    //     this.todo = data;
    //   });
    // }

    public getUserName() {
        this.apiModulesService.get('telegram/user/list?type=all').subscribe((data) => {
            this.username = data;
        });
    }

    public getExternalChannel() {
        this.apiModulesService.get('telegram/channel/extern-channel-get/' + this.route.snapshot.paramMap.get('id')).subscribe((data) => {
            this.done = data.channelMap;
            this.todo = data.channelUnMap;
            console.log(data);
            this.checkoutForm.patchValue({
                userid: data.user.user_id
            });

        });
    }

    onSubmit() {
        if (this.checkoutForm.value.name.length == 0) {
            for (var i = 0; i < this.done.length; i++) {
                this.checkoutForm.value.name.push(this.done[i].channel_id);

            }
            this.apiModulesService.add(this.checkoutForm.value, 'telegram/channel/extern-channel-map').subscribe((data) => {
                console.log(data);
            });
        } else {
            this.apiModulesService.add(this.checkoutForm.value, 'telegram/channel/extern-channel-map').subscribe((data) => {
                console.log(data);
            });
        }


    }

}
